<template>
  <div class="details__wrapper" v-if="datailsObject !== null">
    <span>
      <strong>DETAILS</strong>
    </span>
    <div class="details__squares">
      <card>
        <details-square />
      </card>
      <card>
        <annotations-square />
      </card>
    </div>
  </div>
</template>

<script>
import DetailsSquare from "./DetailsSquare/DetailsSqure";
import AnnotationsSquare from "./DetailsSquare/AnnotationsSquare";

export default {
  components: {
    DetailsSquare,
    AnnotationsSquare
  },
  computed: {
    annotationsObject() {
      return this.$store.getters.annotationsObject;
    },
    datailsObject() {
      return this.$store.getters.detailsObject;
    }
  }
};
</script>
<style lang="scss">
.details {
  &__wrapper {
    margin-top: 25px;

    @media only screen and (min-width: 320px) and (max-width: 768px) {
      padding: 0;
    }
  }

  &__squares {
    display: flex;
    //justify-content: space-around;

    & > * {
      width: 50%;

      @media only screen and (min-width: 768px) {
        &:not(:last-child) {
          margin-right: 16px;
        }
      }
    }

    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }

    .square {
      margin-top: 0;
      width: 100%;
      border: 0;
    }
  }
}
</style>
